import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import { useCreateWeeklyFeedbackMutation } from 'documents/createWeeklyFeedback.generated';
import { WeeklyFeedback } from 'generated/webapp_gql';
import { useRedirectToEmployeeDetails } from 'hooks';
import { Toast } from 'ui';
import { UpdateFeedbacksList } from 'hooks/utils/updateFeedbacksList';

export const useCreateWeeklyFeedback = (employeeId: number) => {
  const { t } = useTranslation();
  const { redirectToEmployeeDetails } = useRedirectToEmployeeDetails();

  const [createWeeklyFeedback, { loading: isCreateWeeklyFeedbackLoading }] = useCreateWeeklyFeedbackMutation({
    update: (cache, { data }) => {
      new UpdateFeedbacksList(cache, data?.createWeeklyFeedback as WeeklyFeedback, employeeId).onCreate();
    },
    onError: (error) => toast.error(error.message),
    onCompleted: () => {
      toast.success(
        <Toast title={t('weeklyForm.toast.weeklyReportHeading')} message={t('weeklyForm.toast.newWeeklyAdded')} />,
      );
      redirectToEmployeeDetails(employeeId);
    },
  });

  return { createWeeklyFeedback, isCreateWeeklyFeedbackLoading };
};
